import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Preloader from './components/Preloader';
import FloatingSocialButtons from './components/FloatingSocialButtons';
import './App.css';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Projects = lazy(() => import('./pages/Projects'));
const Membership = lazy(() => import('./pages/Membership'));
const Contact = lazy(() => import('./pages/Contact'));
const LegalNotices = lazy(() => import('./pages/LegalNotices'));

// Loading component for Suspense fallback
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen bg-white">
    <div className="text-center">
      <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-muted font-medium text-sm">Chargement...</p>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Preloader />
        <Header />
        <main id="main-content">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/projets" element={<Projects />} />
              <Route path="/devenir-membre" element={<Membership />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<LegalNotices />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent />
        <FloatingSocialButtons />
      </div>
    </Router>
  );
}

export default App;
